import qs from 'qs';
import ApiHandler from '../ApiHandler';

class CorelogicApiHander extends ApiHandler {
}

const corelogicApiHander = new CorelogicApiHander();
export default corelogicApiHander;
